<!--
    This plugin have different UI for desktop and mobile devices,
    since it uses mobileUI: small configuration.render

    For mobile devices the list of boat is stacked horizontally.
-->
{#if isMobileOrTablet}
    <section class="mobile-boat-ui horizontal-scroll">
        <div>
            <div class="boat__name size-l mb-5">
                Días track
            </div>
            <div class="boat__heading nowrap">
                <input type="number" min="1" max="10" class="size-s" bind:value={diasTrack} />
            </div>
        </div>
        {#each listOfBoats as boat}
            {@const {IdentificadorMovil, color, Rumbo,Velocidad,nombreMovil } = boat}
            <div
                class="boat mr-20 size-xs clickable"
                style:border-left-color={color}
                on:click={() => displayPopup(IdentificadorMovil)}
            >
                <div class="boat__name size-l mb-5">
                    {nombreMovil}
                </div>
                <div class="boat__heading nowrap">
                    Identificador: {IdentificadorMovil}<br />
                    Rumbo:&nbsp;{Rumbo}°
                    {#if boat.Tecnologia=='AVL'}
						Velocidad:&nbsp;{Velocidad} km/h
					{:else}
						Velocidad:&nbsp;{Velocidad} mn/h
					{/if}
                </div>
            </div>
        {/each}
    </section>
{:else}
    <section class="plugin__content">
        <div class="mb-30 centered">
            <div
                class="button button--variant-orange size-s"
                on:click={() => bcast.emit('rqstOpen', 'menu')}
            >
                Back to menu
            </div>
            Días track: <input type="number" min="1" max="10" class="size-s" bind:value={diasTrack} />
        </div>
        {#each listOfBoats as boat}
            {@const { IdentificadorMovil, color, Rumbo,nombreMovil,Velocidad } = boat}
            <div
                class="boat mb-20 size-xs clickable"
                style:border-left-color={color}
                on:click={() => displayPopup(IdentificadorMovil)}
            >
                <div class="boat__name size-l mb-5">
                    {nombreMovil}
                </div>
                <div class="boat__rank">
                    Identificador: {IdentificadorMovil}
                </div>

				<div class="boat__heading">
					Rumbo: {Rumbo}°
				</div>

                <div class="boat__speed">

				{#if boat.Tecnologia=='AVL'}
					Velocidad: {Velocidad} km/h
				{:else}
					Velocidad: {Velocidad} mn/h
				{/if}

                </div>
            </div>
        {/each}
    </section>
{/if}

// plugin.svelte
<script lang="ts">
    import bcast from '@windy/broadcast';
    import { map } from '@windy/map';
    import { isMobileOrTablet } from '@windy/rootScope';
    import { onMount, onDestroy } from 'svelte';
    import { boatIcon } from './boatIcon';
	import { passwordEnc } from './variables';
    import type { DisplayedBoat, ExtendedMarker, Reporte } from './boatTypes';

    let interval: number = -1;
    let diasTrack = 1;
    let markers: ExtendedMarker[] = [];
    let lines: L.Polyline[] = [];
    let listOfBoats: DisplayedBoat[] = [];
    let openedPopup: L.Popup | null = null;

	async function generarClave(password) {
		const enc = new TextEncoder();
		const keyMaterial = await crypto.subtle.importKey(
			"raw",
			enc.encode(password),
			{ name: "PBKDF2" },
			false,
			["deriveKey"]
		);

		// Derivamos una clave AES-GCM desde la contraseña
		return crypto.subtle.deriveKey(
		{
			name: "PBKDF2",
			salt: enc.encode("mi-sal-fija"), // usa una sal fija o almacenada
			iterations: 100000,
			hash: "SHA-256",
		},
		keyMaterial,
		{ name: "AES-GCM", length: 256 },
		false,
		["encrypt", "decrypt"]
		);
	}

	async function cifrarTexto(texto, password) {
		const clave = await generarClave(password);
		const iv = crypto.getRandomValues(new Uint8Array(12)); // vector de inicialización
		const enc = new TextEncoder();
		const cifrado = await crypto.subtle.encrypt(
		{ name: "AES-GCM", iv },
		clave,
		enc.encode(texto)
		);
		return {
		iv: Array.from(iv),
		data: btoa(String.fromCharCode(...new Uint8Array(cifrado))),
		};
	}

	async function descifrarTexto(cifrado, password) {
		const clave = await generarClave(password);
		const iv = new Uint8Array(cifrado.iv);
		const data = Uint8Array.from(atob(cifrado.data), c => c.charCodeAt(0));
		const descifrado = await crypto.subtle.decrypt(
		{ name: "AES-GCM", iv },
		clave,
		data
		);
		return new TextDecoder().decode(descifrado);
	}
    
	async function obtenerClave(): string {

        let clave = localStorage.getItem('apipass');
        if (!clave) {
            clave = prompt('Ingrese su clave de usuario:') || '';
            if (clave) {
			    clave = JSON.stringify(await cifrarTexto(clave, passwordEnc));
                localStorage.setItem('apipass', clave);
            }
        }
        return await descifrarTexto(JSON.parse(clave), passwordEnc);
    }
	

    async function consultaAutenticada(url: string): Promise<any> {
        let clave = await obtenerClave();
        let headers = { Authorization: 'Basic ' + clave };
        let response = null;
        try {
            response = await fetch(url, { method: 'GET', headers });

			if (!response.ok) {
				throw {
				name: 'FetchError',
				message: `Error HTTP ${response.status}`,
				status: response.status
				};
			}
			
            return await response.json();
        } catch (error: any) {

			const errorInfo = {
				message: error.message,
				name: error.name,
				stack: error.stack,
				status: error.status || null
			};

			console.error('Error en consultaAutenticada:', JSON.stringify(errorInfo));
			
			if (error.status === 401) {
				alert('Clave Incorrecta');
				localStorage.removeItem('apipass');
				clave = await obtenerClave();
				return consultaAutenticada(url);
			}

        }
    }

    const updateIconStyles = () => {
        for (const extendedMarker of markers) {
            const { marker } = extendedMarker;
            if (marker._icon) {
                marker._icon.style.transformOrigin = '12px 12px';
                const heading = marker._icon.getAttribute('data-heading');
                if (marker._icon.style.transform.indexOf('rotateZ') === -1) {
                    marker._icon.style.transform += ` rotateZ(${heading || 0}deg)`;
                }
            }
        }
    };

    const displayPopup = (sail: string) => {
        openedPopup?.remove();
        const clickedBoat = markers.find(m => m.sail === sail);
        if (!clickedBoat) throw new Error('Boat not found!');

        const { latestPosition, nombreMovil } = clickedBoat;
        const date = new Date(latestPosition.FechaReporte);
        const datelocal = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

        let html = `Movíl: ${nombreMovil}<br />`;
        html += `Identificador: ${latestPosition.IdentificadorMovil}<br /><br />`;
        html += `Fecha Reporte: ${datelocal.toLocaleString('es-CL')}<br />`;
        html += `Velocidad: ${latestPosition.Velocidad} ${latestPosition.Tecnologia === 'AVL' ? 'km/h' : 'mn/h'}<br />`;
        html += `Rumbo: ${latestPosition.Rumbo}°<br />`;
        html += `Evento: ${latestPosition.Evento}<br />`;
        html += `Latitud: ${latestPosition.Latitud}<br />`;
        html += `Longitud: ${latestPosition.Longitud}<br />`;

        openedPopup = new L.Popup({ autoClose: false, closeOnClick: false })
            .setLatLng({ lat: latestPosition.Latitud, lng: latestPosition.Longitud })
            .setContent(html)
            .openOn(map);
    };

    const loadResults = async () => {
        try {
            removeAllMapFeatures();


            const data = await consultaAutenticada('https://gateway.marimsys.cl/API/VMS/GENObtenerMoviles');
            if (data.Error.IDError !== 0) return;

            const dNow = new Date();
            const date = new Date(dNow.valueOf());
            date.setDate(date.getDate() - diasTrack);

            const formatedDateHasta = `${("0" + dNow.getUTCDate()).slice(-2)}/${("0" + (dNow.getUTCMonth() + 1)).slice(-2)}/${dNow.getUTCFullYear()} ${("0" + dNow.getUTCHours()).slice(-2)}:${("0" + dNow.getUTCMinutes()).slice(-2)}:${("0" + dNow.getUTCSeconds()).slice(-2)}`;
            const formatedDateDesde = `${("0" + date.getUTCDate()).slice(-2)}/${("0" + (date.getUTCMonth() + 1)).slice(-2)}/${date.getUTCFullYear()} ${("0" + date.getUTCHours()).slice(-2)}:${("0" + date.getUTCMinutes()).slice(-2)}:${("0" + date.getUTCSeconds()).slice(-2)}`;

            let hue = 0;
            const temporaryListOfBoats: DisplayedBoat[] = [];

            for (const element of data.Moviles) {
                const sail = element.IdentificadorMovil;
                let tecnologia = 'VMS';
                if (element.Tecnologia.includes('SMC') && !element.Tecnologia.includes('VMS')) tecnologia = 'SMC';
                else if (element.Tecnologia.includes('AVL')) tecnologia = 'AVL';

                const reportes: Reporte[] = await consultaAutenticada(
                    `https://gateway.marimsys.cl/API/${tecnologia}/GENObtenerReportesEvento?Tipo=1&FechaDesde=${formatedDateDesde}&FechaHasta=${formatedDateHasta}&IdentificadorMovil=${sail}`
                )
				.then(data => {
					if (data?.Error?.IDError === 0) {
						return data.Reportes || [];
					}
					return [];
				});


                if (reportes.length > 0) {
                    hue = (hue + 60) % 360;
                    const track = reportes.map(data => ({ lat: data.Latitud, lng: data.Longitud }));
                    const color = `hsl(${hue}, 100%, 45%)`;

                    const layer = new L.Polyline(track, { color, weight: 2 }).addTo(map);
                    layer.on('mouseover', () => layer.setStyle({ weight: 4 }));
                    layer.on('mouseout', () => layer.setStyle({ weight: 2 }));

                    const latestPosition = track[track.length - 1];
                    const realLast = reportes[reportes.length - 1];
                    realLast.Tecnologia = tecnologia;

                    const marker = new L.Marker(latestPosition, {
                        icon: boatIcon,
                        title: element.DescripcionMovil
                    }).addTo(map);

                    markers.push({ sail, marker, latestPosition: realLast, nombreMovil: element.DescripcionMovil });
                    marker._icon.setAttribute('data-heading', String(realLast.Rumbo));
                    marker.on('click', () => displayPopup(sail));
                    lines.push(layer);

                    const displayedBoat: DisplayedBoat = { ...realLast, color, nombreMovil: element.DescripcionMovil, Tecnologia: tecnologia };
                    temporaryListOfBoats.push(displayedBoat);

                    updateIconStyles();
                }
            }

            listOfBoats = temporaryListOfBoats;
        } catch (error) {
            console.error('Error al cargar resultados:', error);
        }
    };

    const removeAllMapFeatures = () => {
        openedPopup?.remove();
        markers.forEach(l => map.removeLayer(l.marker));
        lines.forEach(l => map.removeLayer(l));
        markers = [];
        lines = [];
    };

    export const onopen = () => {
        loadResults();
        interval = setInterval(loadResults, 60000);
    };

    onMount(() => {
        map.on('zoom', updateIconStyles);
        map.on('zoomend', updateIconStyles);
        map.on('viewreset', updateIconStyles);
    });

    onDestroy(() => {
        removeAllMapFeatures();
        clearInterval(interval);
        map.off('zoom', updateIconStyles);
        map.off('zoomend', updateIconStyles);
        map.off('viewreset', updateIconStyles);
    });
</script>


<style lang="less">
    .plugin__content {
        padding-top: 5px;
    }
    .boat {
        padding-left: 7px;
        border-left: 5px solid;
        &__speed {
            white-space: nowrap;
        }
    }
    .mobile-boat-ui {
        display: flex;
        flex-direction: row;
        align-items: center;
        overflow: auto;
    }

</style>
